/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SignupImport } from './routes/signup'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RecoverPasswordImport } from './routes/recover-password'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as EmbedAppImport } from './routes/embed.app'
import { Route as LayoutSubjectsImport } from './routes/_layout/subjects'
import { Route as LayoutStudyImport } from './routes/_layout/study'
import { Route as LayoutSettingsImport } from './routes/_layout/settings'
import { Route as LayoutSearchImport } from './routes/_layout/search'
import { Route as LayoutSavedQuestionsImport } from './routes/_layout/saved-questions'
import { Route as LayoutQuizzesImport } from './routes/_layout/quizzes'
import { Route as LayoutQuizManagementImport } from './routes/_layout/quiz-management'
import { Route as LayoutQuestionsImport } from './routes/_layout/questions'
import { Route as LayoutProgramsImport } from './routes/_layout/programs'
import { Route as LayoutPracticeQuizzesImport } from './routes/_layout/practice-quizzes'
import { Route as LayoutOrganizationsImport } from './routes/_layout/organizations'
import { Route as LayoutMyFeedbackImport } from './routes/_layout/my-feedback'
import { Route as LayoutItemsImport } from './routes/_layout/items'
import { Route as LayoutFlashcardsImport } from './routes/_layout/flashcards'
import { Route as LayoutFeedbackImport } from './routes/_layout/feedback'
import { Route as LayoutAttemptsHistoryImport } from './routes/_layout/attempts-history'
import { Route as LayoutAdminImport } from './routes/_layout/admin'
import { Route as LayoutStudyIndexImport } from './routes/_layout/study.index'
import { Route as LayoutQuizzesIndexImport } from './routes/_layout/quizzes.index'
import { Route as LayoutQuizManagementIndexImport } from './routes/_layout/quiz-management.index'
import { Route as LayoutQuestionsIndexImport } from './routes/_layout/questions.index'
import { Route as LayoutProgramsIndexImport } from './routes/_layout/programs.index'
import { Route as LayoutOrganizationsIndexImport } from './routes/_layout/organizations.index'
import { Route as LayoutFlashcardsIndexImport } from './routes/_layout/flashcards.index'
import { Route as LayoutAdminTopicsIndexImport } from './routes/_layout/admin-topics.index'
import { Route as LayoutAdminTopicProposalsIndexImport } from './routes/_layout/admin-topic-proposals.index'
import { Route as LayoutAdminTopicMergeIndexImport } from './routes/_layout/admin-topic-merge.index'
import { Route as LayoutStudySavedImport } from './routes/_layout/study.saved'
import { Route as LayoutStudyDueImport } from './routes/_layout/study.due'
import { Route as LayoutStudyCustomImport } from './routes/_layout/study.custom'
import { Route as LayoutStudyDeckIdImport } from './routes/_layout/study.$deckId'
import { Route as LayoutQuizzesQuizIdImport } from './routes/_layout/quizzes.$quizId'
import { Route as LayoutQuizManagementAddImport } from './routes/_layout/quiz-management.add'
import { Route as LayoutQuestionsAddImport } from './routes/_layout/questions.add'
import { Route as LayoutProgramsIdImport } from './routes/_layout/programs.$id'
import { Route as LayoutFlashcardsAddImport } from './routes/_layout/flashcards.add'
import { Route as LayoutAdminTopicsTopicIdImport } from './routes/_layout/admin-topics.$topicId'
import { Route as LayoutStudySavedIndexImport } from './routes/_layout/study.saved.index'
import { Route as LayoutFlashcardsNotesIndexImport } from './routes/_layout/flashcards.notes.index'
import { Route as LayoutStudySavedCardIdImport } from './routes/_layout/study.saved.$cardId'
import { Route as LayoutQuizManagementQuizIdPrintImport } from './routes/_layout/quiz-management.$quizId.print'
import { Route as LayoutQuizManagementQuizIdExportImport } from './routes/_layout/quiz-management.$quizId.export'
import { Route as LayoutQuizManagementQuizIdEditImport } from './routes/_layout/quiz-management.$quizId.edit'
import { Route as LayoutQuizManagementQuizIdAnalyticsImport } from './routes/_layout/quiz-management.$quizId.analytics'
import { Route as LayoutQuestionsQuestionIdHistoryImport } from './routes/_layout/questions.$questionId.history'
import { Route as LayoutQuestionsQuestionIdFeedbackImport } from './routes/_layout/questions.$questionId.feedback'
import { Route as LayoutQuestionsQuestionIdEditImport } from './routes/_layout/questions.$questionId.edit'
import { Route as LayoutQuestionsQuestionIdAnalyticsImport } from './routes/_layout/questions.$questionId.analytics'
import { Route as LayoutOrganizationsOrganizationIdMembersImport } from './routes/_layout/organizations.$organizationId.members'
import { Route as LayoutOrganizationsOrganizationIdBrandingImport } from './routes/_layout/organizations.$organizationId.branding'
import { Route as LayoutFlashcardsNotesStudentIdImport } from './routes/_layout/flashcards.notes.$studentId'
import { Route as LayoutFlashcardsDeckIdEditImport } from './routes/_layout/flashcards.$deckId.edit'
import { Route as LayoutOrganizationsOrganizationIdAnalyticsSchoolsImport } from './routes/_layout/organizations.$organizationId.analytics.schools'
import { Route as LayoutFlashcardsNotesCardsCardIdImport } from './routes/_layout/flashcards.notes.cards.$cardId'
import { Route as LayoutFlashcardsDeckIdCardsAddImport } from './routes/_layout/flashcards.$deckId.cards.add'
import { Route as LayoutQuizzesQuizIdAttemptsAttemptIdReviewImport } from './routes/_layout/quizzes.$quizId.attempts.$attemptId.review'
import { Route as LayoutFlashcardsDeckIdCardsCardIdEditImport } from './routes/_layout/flashcards.$deckId.cards.$cardId.edit'
import { Route as LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexImport } from './routes/_layout/quizzes.$quizId.attempt.$attemptId.question.$questionIndex'
import { Route as LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexReviewImport } from './routes/_layout/quizzes.$quizId.attempt.$attemptId.question.$questionIndex.review'

// Create/Update Routes

const SignupRoute = SignupImport.update({
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RecoverPasswordRoute = RecoverPasswordImport.update({
  path: '/recover-password',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const EmbedAppRoute = EmbedAppImport.update({
  path: '/embed/app',
  getParentRoute: () => rootRoute,
} as any)

const LayoutSubjectsRoute = LayoutSubjectsImport.update({
  path: '/subjects',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutStudyRoute = LayoutStudyImport.update({
  path: '/study',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsRoute = LayoutSettingsImport.update({
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSearchRoute = LayoutSearchImport.update({
  path: '/search',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSavedQuestionsRoute = LayoutSavedQuestionsImport.update({
  path: '/saved-questions',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutQuizzesRoute = LayoutQuizzesImport.update({
  path: '/quizzes',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutQuizManagementRoute = LayoutQuizManagementImport.update({
  path: '/quiz-management',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutQuestionsRoute = LayoutQuestionsImport.update({
  path: '/questions',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutProgramsRoute = LayoutProgramsImport.update({
  path: '/programs',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPracticeQuizzesRoute = LayoutPracticeQuizzesImport.update({
  path: '/practice-quizzes',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutOrganizationsRoute = LayoutOrganizationsImport.update({
  path: '/organizations',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMyFeedbackRoute = LayoutMyFeedbackImport.update({
  path: '/my-feedback',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutItemsRoute = LayoutItemsImport.update({
  path: '/items',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutFlashcardsRoute = LayoutFlashcardsImport.update({
  path: '/flashcards',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutFeedbackRoute = LayoutFeedbackImport.update({
  path: '/feedback',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAttemptsHistoryRoute = LayoutAttemptsHistoryImport.update({
  path: '/attempts-history',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminRoute = LayoutAdminImport.update({
  path: '/admin',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutStudyIndexRoute = LayoutStudyIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutStudyRoute,
} as any)

const LayoutQuizzesIndexRoute = LayoutQuizzesIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutQuizzesRoute,
} as any)

const LayoutQuizManagementIndexRoute = LayoutQuizManagementIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutQuizManagementRoute,
} as any)

const LayoutQuestionsIndexRoute = LayoutQuestionsIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutQuestionsRoute,
} as any)

const LayoutProgramsIndexRoute = LayoutProgramsIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutProgramsRoute,
} as any)

const LayoutOrganizationsIndexRoute = LayoutOrganizationsIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutOrganizationsRoute,
} as any)

const LayoutFlashcardsIndexRoute = LayoutFlashcardsIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutFlashcardsRoute,
} as any)

const LayoutAdminTopicsIndexRoute = LayoutAdminTopicsIndexImport.update({
  path: '/admin-topics/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminTopicProposalsIndexRoute =
  LayoutAdminTopicProposalsIndexImport.update({
    path: '/admin-topic-proposals/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutAdminTopicMergeIndexRoute = LayoutAdminTopicMergeIndexImport.update(
  {
    path: '/admin-topic-merge/',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutStudySavedRoute = LayoutStudySavedImport.update({
  path: '/saved',
  getParentRoute: () => LayoutStudyRoute,
} as any)

const LayoutStudyDueRoute = LayoutStudyDueImport.update({
  path: '/due',
  getParentRoute: () => LayoutStudyRoute,
} as any)

const LayoutStudyCustomRoute = LayoutStudyCustomImport.update({
  path: '/custom',
  getParentRoute: () => LayoutStudyRoute,
} as any)

const LayoutStudyDeckIdRoute = LayoutStudyDeckIdImport.update({
  path: '/$deckId',
  getParentRoute: () => LayoutStudyRoute,
} as any)

const LayoutQuizzesQuizIdRoute = LayoutQuizzesQuizIdImport.update({
  path: '/$quizId',
  getParentRoute: () => LayoutQuizzesRoute,
} as any)

const LayoutQuizManagementAddRoute = LayoutQuizManagementAddImport.update({
  path: '/add',
  getParentRoute: () => LayoutQuizManagementRoute,
} as any)

const LayoutQuestionsAddRoute = LayoutQuestionsAddImport.update({
  path: '/add',
  getParentRoute: () => LayoutQuestionsRoute,
} as any)

const LayoutProgramsIdRoute = LayoutProgramsIdImport.update({
  path: '/$id',
  getParentRoute: () => LayoutProgramsRoute,
} as any)

const LayoutFlashcardsAddRoute = LayoutFlashcardsAddImport.update({
  path: '/add',
  getParentRoute: () => LayoutFlashcardsRoute,
} as any)

const LayoutAdminTopicsTopicIdRoute = LayoutAdminTopicsTopicIdImport.update({
  path: '/admin-topics/$topicId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutStudySavedIndexRoute = LayoutStudySavedIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutStudySavedRoute,
} as any)

const LayoutFlashcardsNotesIndexRoute = LayoutFlashcardsNotesIndexImport.update(
  {
    path: '/notes/',
    getParentRoute: () => LayoutFlashcardsRoute,
  } as any,
)

const LayoutStudySavedCardIdRoute = LayoutStudySavedCardIdImport.update({
  path: '/$cardId',
  getParentRoute: () => LayoutStudySavedRoute,
} as any)

const LayoutQuizManagementQuizIdPrintRoute =
  LayoutQuizManagementQuizIdPrintImport.update({
    path: '/$quizId/print',
    getParentRoute: () => LayoutQuizManagementRoute,
  } as any)

const LayoutQuizManagementQuizIdExportRoute =
  LayoutQuizManagementQuizIdExportImport.update({
    path: '/$quizId/export',
    getParentRoute: () => LayoutQuizManagementRoute,
  } as any)

const LayoutQuizManagementQuizIdEditRoute =
  LayoutQuizManagementQuizIdEditImport.update({
    path: '/$quizId/edit',
    getParentRoute: () => LayoutQuizManagementRoute,
  } as any)

const LayoutQuizManagementQuizIdAnalyticsRoute =
  LayoutQuizManagementQuizIdAnalyticsImport.update({
    path: '/$quizId/analytics',
    getParentRoute: () => LayoutQuizManagementRoute,
  } as any)

const LayoutQuestionsQuestionIdHistoryRoute =
  LayoutQuestionsQuestionIdHistoryImport.update({
    path: '/$questionId/history',
    getParentRoute: () => LayoutQuestionsRoute,
  } as any)

const LayoutQuestionsQuestionIdFeedbackRoute =
  LayoutQuestionsQuestionIdFeedbackImport.update({
    path: '/$questionId/feedback',
    getParentRoute: () => LayoutQuestionsRoute,
  } as any)

const LayoutQuestionsQuestionIdEditRoute =
  LayoutQuestionsQuestionIdEditImport.update({
    path: '/$questionId/edit',
    getParentRoute: () => LayoutQuestionsRoute,
  } as any)

const LayoutQuestionsQuestionIdAnalyticsRoute =
  LayoutQuestionsQuestionIdAnalyticsImport.update({
    path: '/$questionId/analytics',
    getParentRoute: () => LayoutQuestionsRoute,
  } as any)

const LayoutOrganizationsOrganizationIdMembersRoute =
  LayoutOrganizationsOrganizationIdMembersImport.update({
    path: '/$organizationId/members',
    getParentRoute: () => LayoutOrganizationsRoute,
  } as any)

const LayoutOrganizationsOrganizationIdBrandingRoute =
  LayoutOrganizationsOrganizationIdBrandingImport.update({
    path: '/$organizationId/branding',
    getParentRoute: () => LayoutOrganizationsRoute,
  } as any)

const LayoutFlashcardsNotesStudentIdRoute =
  LayoutFlashcardsNotesStudentIdImport.update({
    path: '/notes/$studentId',
    getParentRoute: () => LayoutFlashcardsRoute,
  } as any)

const LayoutFlashcardsDeckIdEditRoute = LayoutFlashcardsDeckIdEditImport.update(
  {
    path: '/$deckId/edit',
    getParentRoute: () => LayoutFlashcardsRoute,
  } as any,
)

const LayoutOrganizationsOrganizationIdAnalyticsSchoolsRoute =
  LayoutOrganizationsOrganizationIdAnalyticsSchoolsImport.update({
    path: '/$organizationId/analytics/schools',
    getParentRoute: () => LayoutOrganizationsRoute,
  } as any)

const LayoutFlashcardsNotesCardsCardIdRoute =
  LayoutFlashcardsNotesCardsCardIdImport.update({
    path: '/notes/cards/$cardId',
    getParentRoute: () => LayoutFlashcardsRoute,
  } as any)

const LayoutFlashcardsDeckIdCardsAddRoute =
  LayoutFlashcardsDeckIdCardsAddImport.update({
    path: '/$deckId/cards/add',
    getParentRoute: () => LayoutFlashcardsRoute,
  } as any)

const LayoutQuizzesQuizIdAttemptsAttemptIdReviewRoute =
  LayoutQuizzesQuizIdAttemptsAttemptIdReviewImport.update({
    path: '/attempts/$attemptId/review',
    getParentRoute: () => LayoutQuizzesQuizIdRoute,
  } as any)

const LayoutFlashcardsDeckIdCardsCardIdEditRoute =
  LayoutFlashcardsDeckIdCardsCardIdEditImport.update({
    path: '/$deckId/cards/$cardId/edit',
    getParentRoute: () => LayoutFlashcardsRoute,
  } as any)

const LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexRoute =
  LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexImport.update({
    path: '/attempt/$attemptId/question/$questionIndex',
    getParentRoute: () => LayoutQuizzesQuizIdRoute,
  } as any)

const LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexReviewRoute =
  LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexReviewImport.update({
    path: '/review',
    getParentRoute: () =>
      LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/recover-password': {
      preLoaderRoute: typeof RecoverPasswordImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/_layout/admin': {
      preLoaderRoute: typeof LayoutAdminImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/attempts-history': {
      preLoaderRoute: typeof LayoutAttemptsHistoryImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/feedback': {
      preLoaderRoute: typeof LayoutFeedbackImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/flashcards': {
      preLoaderRoute: typeof LayoutFlashcardsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/items': {
      preLoaderRoute: typeof LayoutItemsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/my-feedback': {
      preLoaderRoute: typeof LayoutMyFeedbackImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/organizations': {
      preLoaderRoute: typeof LayoutOrganizationsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/practice-quizzes': {
      preLoaderRoute: typeof LayoutPracticeQuizzesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/programs': {
      preLoaderRoute: typeof LayoutProgramsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/questions': {
      preLoaderRoute: typeof LayoutQuestionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/quiz-management': {
      preLoaderRoute: typeof LayoutQuizManagementImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/quizzes': {
      preLoaderRoute: typeof LayoutQuizzesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/saved-questions': {
      preLoaderRoute: typeof LayoutSavedQuestionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/search': {
      preLoaderRoute: typeof LayoutSearchImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings': {
      preLoaderRoute: typeof LayoutSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/study': {
      preLoaderRoute: typeof LayoutStudyImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/subjects': {
      preLoaderRoute: typeof LayoutSubjectsImport
      parentRoute: typeof LayoutImport
    }
    '/embed/app': {
      preLoaderRoute: typeof EmbedAppImport
      parentRoute: typeof rootRoute
    }
    '/_layout/': {
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-topics/$topicId': {
      preLoaderRoute: typeof LayoutAdminTopicsTopicIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/flashcards/add': {
      preLoaderRoute: typeof LayoutFlashcardsAddImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/programs/$id': {
      preLoaderRoute: typeof LayoutProgramsIdImport
      parentRoute: typeof LayoutProgramsImport
    }
    '/_layout/questions/add': {
      preLoaderRoute: typeof LayoutQuestionsAddImport
      parentRoute: typeof LayoutQuestionsImport
    }
    '/_layout/quiz-management/add': {
      preLoaderRoute: typeof LayoutQuizManagementAddImport
      parentRoute: typeof LayoutQuizManagementImport
    }
    '/_layout/quizzes/$quizId': {
      preLoaderRoute: typeof LayoutQuizzesQuizIdImport
      parentRoute: typeof LayoutQuizzesImport
    }
    '/_layout/study/$deckId': {
      preLoaderRoute: typeof LayoutStudyDeckIdImport
      parentRoute: typeof LayoutStudyImport
    }
    '/_layout/study/custom': {
      preLoaderRoute: typeof LayoutStudyCustomImport
      parentRoute: typeof LayoutStudyImport
    }
    '/_layout/study/due': {
      preLoaderRoute: typeof LayoutStudyDueImport
      parentRoute: typeof LayoutStudyImport
    }
    '/_layout/study/saved': {
      preLoaderRoute: typeof LayoutStudySavedImport
      parentRoute: typeof LayoutStudyImport
    }
    '/_layout/admin-topic-merge/': {
      preLoaderRoute: typeof LayoutAdminTopicMergeIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-topic-proposals/': {
      preLoaderRoute: typeof LayoutAdminTopicProposalsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-topics/': {
      preLoaderRoute: typeof LayoutAdminTopicsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/flashcards/': {
      preLoaderRoute: typeof LayoutFlashcardsIndexImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/organizations/': {
      preLoaderRoute: typeof LayoutOrganizationsIndexImport
      parentRoute: typeof LayoutOrganizationsImport
    }
    '/_layout/programs/': {
      preLoaderRoute: typeof LayoutProgramsIndexImport
      parentRoute: typeof LayoutProgramsImport
    }
    '/_layout/questions/': {
      preLoaderRoute: typeof LayoutQuestionsIndexImport
      parentRoute: typeof LayoutQuestionsImport
    }
    '/_layout/quiz-management/': {
      preLoaderRoute: typeof LayoutQuizManagementIndexImport
      parentRoute: typeof LayoutQuizManagementImport
    }
    '/_layout/quizzes/': {
      preLoaderRoute: typeof LayoutQuizzesIndexImport
      parentRoute: typeof LayoutQuizzesImport
    }
    '/_layout/study/': {
      preLoaderRoute: typeof LayoutStudyIndexImport
      parentRoute: typeof LayoutStudyImport
    }
    '/_layout/flashcards/$deckId/edit': {
      preLoaderRoute: typeof LayoutFlashcardsDeckIdEditImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/flashcards/notes/$studentId': {
      preLoaderRoute: typeof LayoutFlashcardsNotesStudentIdImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/organizations/$organizationId/branding': {
      preLoaderRoute: typeof LayoutOrganizationsOrganizationIdBrandingImport
      parentRoute: typeof LayoutOrganizationsImport
    }
    '/_layout/organizations/$organizationId/members': {
      preLoaderRoute: typeof LayoutOrganizationsOrganizationIdMembersImport
      parentRoute: typeof LayoutOrganizationsImport
    }
    '/_layout/questions/$questionId/analytics': {
      preLoaderRoute: typeof LayoutQuestionsQuestionIdAnalyticsImport
      parentRoute: typeof LayoutQuestionsImport
    }
    '/_layout/questions/$questionId/edit': {
      preLoaderRoute: typeof LayoutQuestionsQuestionIdEditImport
      parentRoute: typeof LayoutQuestionsImport
    }
    '/_layout/questions/$questionId/feedback': {
      preLoaderRoute: typeof LayoutQuestionsQuestionIdFeedbackImport
      parentRoute: typeof LayoutQuestionsImport
    }
    '/_layout/questions/$questionId/history': {
      preLoaderRoute: typeof LayoutQuestionsQuestionIdHistoryImport
      parentRoute: typeof LayoutQuestionsImport
    }
    '/_layout/quiz-management/$quizId/analytics': {
      preLoaderRoute: typeof LayoutQuizManagementQuizIdAnalyticsImport
      parentRoute: typeof LayoutQuizManagementImport
    }
    '/_layout/quiz-management/$quizId/edit': {
      preLoaderRoute: typeof LayoutQuizManagementQuizIdEditImport
      parentRoute: typeof LayoutQuizManagementImport
    }
    '/_layout/quiz-management/$quizId/export': {
      preLoaderRoute: typeof LayoutQuizManagementQuizIdExportImport
      parentRoute: typeof LayoutQuizManagementImport
    }
    '/_layout/quiz-management/$quizId/print': {
      preLoaderRoute: typeof LayoutQuizManagementQuizIdPrintImport
      parentRoute: typeof LayoutQuizManagementImport
    }
    '/_layout/study/saved/$cardId': {
      preLoaderRoute: typeof LayoutStudySavedCardIdImport
      parentRoute: typeof LayoutStudySavedImport
    }
    '/_layout/flashcards/notes/': {
      preLoaderRoute: typeof LayoutFlashcardsNotesIndexImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/study/saved/': {
      preLoaderRoute: typeof LayoutStudySavedIndexImport
      parentRoute: typeof LayoutStudySavedImport
    }
    '/_layout/flashcards/$deckId/cards/add': {
      preLoaderRoute: typeof LayoutFlashcardsDeckIdCardsAddImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/flashcards/notes/cards/$cardId': {
      preLoaderRoute: typeof LayoutFlashcardsNotesCardsCardIdImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/organizations/$organizationId/analytics/schools': {
      preLoaderRoute: typeof LayoutOrganizationsOrganizationIdAnalyticsSchoolsImport
      parentRoute: typeof LayoutOrganizationsImport
    }
    '/_layout/flashcards/$deckId/cards/$cardId/edit': {
      preLoaderRoute: typeof LayoutFlashcardsDeckIdCardsCardIdEditImport
      parentRoute: typeof LayoutFlashcardsImport
    }
    '/_layout/quizzes/$quizId/attempts/$attemptId/review': {
      preLoaderRoute: typeof LayoutQuizzesQuizIdAttemptsAttemptIdReviewImport
      parentRoute: typeof LayoutQuizzesQuizIdImport
    }
    '/_layout/quizzes/$quizId/attempt/$attemptId/question/$questionIndex': {
      preLoaderRoute: typeof LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexImport
      parentRoute: typeof LayoutQuizzesQuizIdImport
    }
    '/_layout/quizzes/$quizId/attempt/$attemptId/question/$questionIndex/review': {
      preLoaderRoute: typeof LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexReviewImport
      parentRoute: typeof LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  LayoutRoute.addChildren([
    LayoutAdminRoute,
    LayoutAttemptsHistoryRoute,
    LayoutFeedbackRoute,
    LayoutFlashcardsRoute.addChildren([
      LayoutFlashcardsAddRoute,
      LayoutFlashcardsIndexRoute,
      LayoutFlashcardsDeckIdEditRoute,
      LayoutFlashcardsNotesStudentIdRoute,
      LayoutFlashcardsNotesIndexRoute,
      LayoutFlashcardsDeckIdCardsAddRoute,
      LayoutFlashcardsNotesCardsCardIdRoute,
      LayoutFlashcardsDeckIdCardsCardIdEditRoute,
    ]),
    LayoutItemsRoute,
    LayoutMyFeedbackRoute,
    LayoutOrganizationsRoute.addChildren([
      LayoutOrganizationsIndexRoute,
      LayoutOrganizationsOrganizationIdBrandingRoute,
      LayoutOrganizationsOrganizationIdMembersRoute,
      LayoutOrganizationsOrganizationIdAnalyticsSchoolsRoute,
    ]),
    LayoutPracticeQuizzesRoute,
    LayoutProgramsRoute.addChildren([
      LayoutProgramsIdRoute,
      LayoutProgramsIndexRoute,
    ]),
    LayoutQuestionsRoute.addChildren([
      LayoutQuestionsAddRoute,
      LayoutQuestionsIndexRoute,
      LayoutQuestionsQuestionIdAnalyticsRoute,
      LayoutQuestionsQuestionIdEditRoute,
      LayoutQuestionsQuestionIdFeedbackRoute,
      LayoutQuestionsQuestionIdHistoryRoute,
    ]),
    LayoutQuizManagementRoute.addChildren([
      LayoutQuizManagementAddRoute,
      LayoutQuizManagementIndexRoute,
      LayoutQuizManagementQuizIdAnalyticsRoute,
      LayoutQuizManagementQuizIdEditRoute,
      LayoutQuizManagementQuizIdExportRoute,
      LayoutQuizManagementQuizIdPrintRoute,
    ]),
    LayoutQuizzesRoute.addChildren([
      LayoutQuizzesQuizIdRoute.addChildren([
        LayoutQuizzesQuizIdAttemptsAttemptIdReviewRoute,
        LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexRoute.addChildren(
          [LayoutQuizzesQuizIdAttemptAttemptIdQuestionQuestionIndexReviewRoute],
        ),
      ]),
      LayoutQuizzesIndexRoute,
    ]),
    LayoutSavedQuestionsRoute,
    LayoutSearchRoute,
    LayoutSettingsRoute,
    LayoutStudyRoute.addChildren([
      LayoutStudyDeckIdRoute,
      LayoutStudyCustomRoute,
      LayoutStudyDueRoute,
      LayoutStudySavedRoute.addChildren([
        LayoutStudySavedCardIdRoute,
        LayoutStudySavedIndexRoute,
      ]),
      LayoutStudyIndexRoute,
    ]),
    LayoutSubjectsRoute,
    LayoutIndexRoute,
    LayoutAdminTopicsTopicIdRoute,
    LayoutAdminTopicMergeIndexRoute,
    LayoutAdminTopicProposalsIndexRoute,
    LayoutAdminTopicsIndexRoute,
  ]),
  LoginRoute,
  LogoutRoute,
  RecoverPasswordRoute,
  ResetPasswordRoute,
  SignupRoute,
  EmbedAppRoute,
])

/* prettier-ignore-end */
